import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/category/roof-repair")({
  beforeLoad: () => { throw redirect({ to: "/blog/category/$category", params: { category: "roof-repair" }, statusCode: 301 }); },
});
